module.exports = {"trackingId":"DUMMY TRACKING ID"}


//////////////////
// WEBPACK FOOTER
// app/js/credentials/googleAnalytics.credentials.json
// module id = 396
// module chunks = 0